module.exports = __webpack_public_path__ + "static/media/support-icon.dee95179.svg";